"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldShowNavigationArrows = void 0;
var _getSlidesPerView = require("./getSlidesPerView");
const shouldShowNavigationArrows = ({
  navigation,
  slider,
  slidesCount
}) => navigation?.showArrows === true && slidesCount > (0, _getSlidesPerView.getSlidesPerView)(slider);
exports.shouldShowNavigationArrows = shouldShowNavigationArrows;
//# sourceMappingURL=shouldShowNavigationArrows.js.map